import React from 'react';
import clsx from 'clsx';

import Modal from 'features/app/components/Modal';
import BaseButton from 'features/app/components/BaseButton';

import { useStyles } from 'features/app/components/ConfirmModal/styles';

type ConfirmModalProps = {
  secondaryButtonText?: string;
  primaryButtonText?: string;
  onSecondaryClick?: () => void;
  onPrimaryClick?: () => void;
  onClose: () => void;
  title?: string;
  open: boolean;
  children?: React.ReactNode;
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  secondaryButtonText,
  primaryButtonText,
  onSecondaryClick,
  onPrimaryClick,
  onClose,
  title,
  open,
  children,
}) => {
  const classes = useStyles();

  return (
    <Modal
      dialogContentClass={classes.dialogContent}
      paperClass={classes.paper}
      onClose={onClose}
      title={title}
      open={open}
    >
      {children}
      {(secondaryButtonText || primaryButtonText) && (
        <div className={classes.modalButtons}>
          {secondaryButtonText && (
            <BaseButton className={clsx(classes.button, classes.buttonSecondary)} onClick={onSecondaryClick}>
              {secondaryButtonText}
            </BaseButton>
          )}
          {primaryButtonText && (
            <BaseButton className={clsx(classes.button, classes.buttonPrimary)} onClick={onPrimaryClick}>
              {primaryButtonText}
            </BaseButton>
          )}
        </div>
      )}
    </Modal>
  );
};

export default ConfirmModal;
